import React from "react";
import { Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { EDITIONS, switchEditionPath, useEdition } from "../bible/edition";

const LanguageSwitch = ({ size = "compact" }) => {
  const edition = useEdition();
  const location = useLocation();
  const navigate = useNavigate();
  const comfortable = size === "comfortable";

  return (
    <Box
      role="group"
      aria-label="Bible language"
      data-testid="language-switch"
      data-size={size}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 999,
        overflow: "hidden",
        height: comfortable ? 44 : { xs: 26, sm: 28 },
        width: comfortable ? "100%" : "auto",
        flexShrink: 0,
      }}
    >
      {Object.values(EDITIONS).map((item) => {
        const active = item.id === edition.id;
        return (
          <Button
            key={item.id}
            size="small"
            onClick={() => {
              if (!active) {
                navigate(switchEditionPath(location.pathname, item.id));
              }
            }}
            aria-pressed={active}
            sx={{
              minWidth: comfortable ? 0 : 0,
              flex: comfortable ? 1 : "0 0 auto",
              px: comfortable ? 1.5 : { xs: 0.45, sm: 1.1 },
              py: 0,
              height: comfortable ? 44 : { xs: 24, sm: 28 },
              minHeight: comfortable ? 44 : undefined,
              borderRadius: 0,
              fontSize: comfortable ? "0.875rem" : { xs: "0.62rem", sm: "0.74rem" },
              fontWeight: active ? 700 : 500,
              letterSpacing: { xs: 0, sm: "0.02em" },
              color: active ? "primary.contrastText" : "text.secondary",
              bgcolor: active ? "primary.main" : "transparent",
              "&:hover": {
                bgcolor: active ? "primary.dark" : "action.hover",
              },
            }}
          >
            {item.id === "zh" ? "中" : item.id === "en" ? "EN" : "对"}
          </Button>
        );
      })}
    </Box>
  );
};

export default LanguageSwitch;
